// Hero.js
import React, { useState, useEffect } from 'react';
import industrialHeroImg from '../assets/hero_6-1.webp';
import { motion } from 'framer-motion';
import enerbyteLogo from '../assets/logos/Enerbyte_logo_conBRAZO.webp';



const Hero = () => {

  const [isGrayscale, setIsGrayscale] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsGrayscale(true);
    }, 10000); // 10 segundos

    return () => clearTimeout(timer); // Limpiar el temporizador en caso de desmontaje
  }, []);


  return (
    <motion.section
      id='inicio'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="relative h-screen w-full overflow-hidden"
    >
      <div
        className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: `url(${industrialHeroImg})`,
          position: 'fixed',
          zIndex: '-1',
        }}
      ></div>
      <div className="relative flex items-center justify-center h-full">
        <div className="text-center text-white p-5 md:p-20 bg-black bg-opacity-70 dark:bg-opacity-80 rounded-lg">
          <motion
            transition={{ duration: 0.5 }}
          >
            <img
              src={enerbyteLogo}
              alt={"EnerByte"}
              className="h-[8.25rem]  w-full object-contain hover:grayscale-0 transition duration-300 ${isGrayscale ? 'grayscale hover:grayscale-0' : ''}"
            />
          </motion>
          <motion.p
            className="text-xl font-semibold mt-4 mb-8"
            initial={{ y: 20 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.7 }}

          >
            Transformando Industrias y Energía para un futuro más eficiente.
          </motion.p>

        </div>
      </div>
    </motion.section>
  );
};

export default Hero;